module.exports = __webpack_public_path__ + "static/media/about-us.fa1e3cf1.jpg";